/**
 * Algolia Hooks - Template Generation and Widget Setup
 * Part of Deuxpardeux Algolia custom implementation
 */

/**
 * Returns promo cards applicable to the current page and viewport.
 *
 * Collection matching (mutually exclusive):
 *   - show_on_all_collections_excluding (non-empty) → show on ALL collections EXCEPT those IDs
 *   - collections (non-empty, fallback)              → show on ONLY those specific collection IDs
 *
 * Viewport:
 *   - hide_on_desktop: skipped when window.innerWidth >= 1024
 *   - hide_on_mobile:  skipped when window.innerWidth < 1024
 */
function getApplicableAlgoliaPromoCards(provinceGroupOverride) {
	const allPromos = Array.isArray(window.algoliaMetaobjectPromoCards)
		? window.algoliaMetaobjectPromoCards
		: [];

	if (!allPromos.length) return [];

	const isSearchTemplate = document.body.classList.contains('template-search');

	const isCollectionTemplate = document.body.classList.contains('template-collection');
	const currentCollectionId = window.currentCollectionId;
	const isDesktop = window.innerWidth >= 1024;

	// Province gating (QC vs ROC segmentation). Normally read from <html>; the
	// hitsPerPage hook passes an explicit group so it can size the grid for both
	// possibilities without depending on when IP detection lands.
	const currentProvinceGroup = provinceGroupOverride !== undefined
		? provinceGroupOverride
		: document.documentElement.getAttribute('data-province-group');

	return allPromos.filter((promo) => {
		if (!promo) return false;

		// Viewport filter
		if (isDesktop && promo.hide_on_desktop) return false;
		if (!isDesktop && promo.hide_on_mobile) return false;

		// Province filter: one optional value per card. Blank = all of Canada.
		// No group on <html> (feature off / theme editor) = show everything.
		if (promo.province && currentProvinceGroup && promo.province !== currentProvinceGroup) return false;

		if (isSearchTemplate) {
			return !!promo.show_on_search_page;
		}

		if (isCollectionTemplate && currentCollectionId) {
			const excludedCollections = Array.isArray(promo.show_on_all_collections_excluding)
				? promo.show_on_all_collections_excluding
				: [];

			// "Show on all collections except…" mode
			if (excludedCollections.length > 0) {
				return !excludedCollections.includes(currentCollectionId);
			}

			// "Show on specific collections" mode
			if (Array.isArray(promo.collections) && promo.collections.length > 0) {
				return promo.collections.includes(currentCollectionId);
			}

			// Both fields empty → show on all collections
			return true;
		}

		return false;
	});
}

// Remove default Algolia styles
document.addEventListener('algolia.hooks.initialize', function () {

	// debugger;
	algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
		// Each promo card that will render takes a slot in the grid, so we ask
		// Algolia for that many fewer products and the page still totals e.g. 24.
		//
		// A QC card and its ROC counterpart occupy ONE slot between them: exactly
		// one is ever visible. Counting them as two is what shrinks the grid.
		// Taking the count "as if QC" and "as if ROC" and keeping the larger
		// expresses that automatically — the shared/ungated cards are in both
		// counts, and each province-scoped pair contributes 1, not 2.
		//
		//   3 ungated + 1 QC + 1 ROC  ->  max(3+1, 3+1) = 4 slots, 4 cards shown.
		//
		// It also makes the number independent of WHEN detection lands, which
		// matters because this hook runs at InstantSearch init and a first-visit
		// Canadian shopper may still be on the QC default at that moment.
		//
		// Province filtering on (storefront or editor) always uses this. The
		// editor's "Show all" mode is the one case where more cards render than
		// slots reserved — deliberate: the QC/ROC switcher positions then match
		// the real storefront exactly, and "Show all" is a comparison view where
		// one extra tile is expected.
		const provinceEnabled = !!(window.DPDProvince && window.DPDProvince.enabled);
		let reservedSlots;

		if (provinceEnabled) {
			const qcCount = getApplicableAlgoliaPromoCards('QC').length;
			const rocCount = getApplicableAlgoliaPromoCards('ROC').length;
			reservedSlots = Math.max(qcCount, rocCount);
			if (qcCount !== rocCount) {
				console.warn(
					'[dpd-province] Uneven promo-card counts (QC: ' + qcCount + ', ROC: ' + rocCount +
					'). Reserving ' + reservedSlots + ' slots, so one province sees a grid ' +
					Math.abs(qcCount - rocCount) + ' item(s) short. Pair each province-scoped card with its counterpart.'
				);
			}
		} else {
			// Province segmentation turned off — every card renders.
			reservedSlots = getApplicableAlgoliaPromoCards().length;
		}

		if (!reservedSlots) {
			return options;
		}

		const currentHitsPerPage = parseInt(options.hitsPerPage, 10);
		if (Number.isNaN(currentHitsPerPage) || currentHitsPerPage <= 0) {
			return options;
		}

		const newHitsPerPage = Math.max(1, currentHitsPerPage - reservedSlots);

		return {
			...options,
			hitsPerPage: newHitsPerPage
		};
	});
	

	const virtualSortingIndexBase = 'shopify_live_products_';
	const virtualSortingOptions = [
		'recently_ordered_count_desc',
		'price_asc',
		'price_desc',
		'title_asc',
		'title_desc',
		'published_at_desc',
		'published_at_asc',
	];

	const finalAlgoliaPrefix = window.final_algolia_market_prefix.length > 0 ? `${window.final_algolia_market_prefix}_` : '';
	const virtualSortingEnabled = window.enable_virtual_sorting == 'true';

	const finalSortingOptions = virtualSortingOptions.map(option => {
		return {
			label: window.algoliaLocales.sorting[option],
			value: `${virtualSortingIndexBase}${finalAlgoliaPrefix}${option}_virtual`,
		};
	});

	console.log('finalSortingOptions', finalSortingOptions);



	if (virtualSortingEnabled) {
		algoliaShopify.hooks.registerHook(
			"beforeISearchInitSortOrdersArray",
			sortOrdersCallback
		);

		algoliaShopify.hooks.registerHook(
			"beforeISInitCollectionSortOrdersArray",
			sortOrdersCallback
		);

		function sortOrdersCallback(transformedSortOrders, sortOrder) {
			// console.log('beforeISearchInitSortOrdersArray arguments', arguments);
			try {
				if (typeof transformedSortOrders !== 'object' || transformedSortOrders === null) {
					transformedSortOrders = {};
				}
	
				const finalSortOrders = [];
				if (transformedSortOrders.label && transformedSortOrders.value) {
					finalSortOrders.push({
						label: transformedSortOrders.label,
						value: transformedSortOrders.value,
					});
				}
				finalSortOrders.push(...finalSortingOptions);
	
				return finalSortOrders;
			} catch (error) {
				return [transformedSortOrders];
			}
		}
	}


	const unsupportedCountries = [
		'AU',
		'BH',
		'CZ',
		'DK',
		'IN',
		'KW',
		'LI',
		'NO',
		'OM',
		'PL',
		'QA',
		'SA',
		'SE',
		'CH',
		'AE',
		'GB',
		'US'
	];

	
	algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {

		// console.log('beforeInstantSearchFiltersString defaultFilter', defaultFilter);

		let additionalFilter = '';
		
		if(defaultFilter) {
			additionalFilter = ' AND NOT tags:ghost_product'
		}
		else {
			additionalFilter = 'NOT tags:ghost_product'
		}

		if(
			(Shopify.locale == "fr" && unsupportedCountries.includes(Shopify.country))
			|| (Shopify.country == "CA" && Shopify.locale == "en")
		) {
			additionalFilter = additionalFilter + ' AND NOT tags:do_not_sell_in_canada'		
		}

		return defaultFilter + additionalFilter;
	});

	const algoliaStyleTag = document.querySelector('#algolia-shopify-instantsearch').previousElementSibling;
	if (algoliaStyleTag && algoliaStyleTag.tagName == 'STYLE') {
		algoliaStyleTag.remove();
	}

	// Filter Type Mapping Configuration
	const FILTER_TYPE_MAP = {
		'default': 'filter-type-checkboxes',
		'options.size': 'filter-type-buttons filter-type-buttons-5col',
		'meta.custom.variant_size_grouping_filter': 'filter-type-buttons filter-type-buttons-5col filter-type-size-sizes',
		// 'meta.productdetails.color': 'filter-type-buttons filter-type-buttons-2col filter-type-color',
		'meta.custom.color_group': 'filter-type-color-swatches',

		'price_range': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.genders_filter': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.review_ratings': 'filter-type-checkboxes filter-type-rating-stars',
		'meta.custom.rating_group': 'filter-type-checkboxes filter-type-rating-stars',
		'meta.custom.discounts': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.discount_percentage': 'filter-type-buttons filter-type-buttons-2col',
		'meta.custom.discount_percentage_usa': 'filter-type-buttons filter-type-buttons-2col',

		'meta.custom.categories_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'meta.custom.subcategories_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'meta.custom.seasons_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'meta.custom.themes_filter': 'filter-type-checkboxes filter-type-checkboxes-1col',
		'tags': 'hidden',

		// Add more mappings as needed
	};

	const FACET_TRANSLATION_MAP = {
		'options.size': 'size',
		'meta.custom.variant_size_grouping_filter': 'size_grouping',
		'meta.productdetails.color_code': 'color',
		'meta.productdetails.color': 'color',
		'meta.custom.color_group': 'color',
		'price_range': 'price',
		'price': 'price',
		'inventory_available': 'in_stock',
		'meta.custom.genders_filter': 'genders',
		'meta.custom.review_ratings': 'reviews',
		'meta.custom.rating_group': 'reviews',
		'meta.custom.discounts': 'discounts',
		'meta.custom.discount_percentage': 'discounts',
		'meta.custom.discount_percentage_usa': 'discounts',
		'meta.custom.categories_filter': 'categories',
		'meta.custom.subcategories_filter': 'subcategories',
		'meta.custom.seasons_filter': 'seasons',
		'meta.custom.themes_filter': 'themes',
		'tags': 'tags',
	};

	algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
		// console.log('HIT', hit);

		// All the HTML generation is now in the helper
		return window.algoliaProductHelpers.createProductCardHTML(hit, {
			html,
			components,
			itemLink: algoliaShopify.helpers.instantsearchLink(hit).split('?')[0],
			trackSearchAttribution,
			algoliaLocales: window.algoliaLocales.badges
		});
	});

	algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
		// Check if this is search template
		window.isSearchTemplate = (document.body?.dataset?.template === 'search') || document.body.classList.contains('template-search');
		
		// Get search term from URL
		const urlTerm = new URLSearchParams(window.location.search).get('q') || '';
		const searchTerm = decodeURIComponent(urlTerm).trim();


		// Build search banner HTML for search template only
		const searchBannerHtml = window.isSearchTemplate ? html`
			<div class="collection-banner-content">
				<span class="visually-hidden">Search:</span>
				<h1 data-search-title>${(window.algoliaLocales?.search_results_for || 'Search results for "[term]"').replace('[term]', `" ${searchTerm} "`)}</h1>
				<span class="collection-count search-count" data-search-count></span>
    		</div> 
		` : '';

		return html
			`<div class="ais-page algolia-custom-layout layout-switching">
				<div class="pagination-scroll-anchor"></div>

				${searchBannerHtml}

				<!-- Search Header -->
				<div class="search-header">
					<div class="search-header-top">

						<button type="button" class="ais-facets-button" style="display: none;"></button>

						<!-- Toggle for sidebar -->
						<button type="button" class="filter-sort-toggle">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<line x1="0" y1="6" x2="24" y2="6"></line>
								<line x1="4" y1="12" x2="20" y2="12"></line>
								<line x1="8" y1="18" x2="16" y2="18"></line>
							</svg>
							<span class="filter-sort-toggle-text">
								<span class="show-filters-text filter-sort-toggle-text-item">${window.algoliaLocales.show_filters}</span>
								<span class="hide-filters-text filter-sort-toggle-text-item">${window.algoliaLocales.hide_filters}</span>
							</span>
							<span class="filter-count-badge" style="display: none;">0</span>
						</button>

						<!-- Product/Worn Toggle -->
						<div class="product-worn-toggle">
							<label class="toggle-switch">
								<input type="checkbox" id="product-worn-toggle" />
								<span class="toggle-indicator"></span>
								<span class="toggle-label">${window.algoliaLocales.product}</span>
								<span class="toggle-label">${window.algoliaLocales.worn}</span>
							</label>
						</div>
					</div>

					
				</div>
        
				<div class="ais-input" style="display: none;">
					<div class="ais-search-box-container"></div>
					<div class="ais-input-button">
						<div class="ais-clear-input-icon"></div>
					</div>
				</div>

				<div class="search-main">
					<div class="search-sidebar">
						<div class="search-sidebar-inner">
							<div class="search-sidebar-header">
								<div class="search-sidebar-title">
									<span>${window.algoliaLocales.filters_title}</span>
									<div class="search-sidebar-title__results-count"></div>
								</div>
								<button class="close-button search-sidebar-close" aria-label="${window.algoliaLocales.close_title}">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
										<line x1="18" y1="6" x2="6" y2="18"></line>
										<line x1="6" y1="6" x2="18" y2="18"></line>
									</svg>
								</button>
							</div>
							
							<div class="ais-current-refined-values-container" style="display: none;"></div>

							<div class="search-header-bottom search-sidebar-active-filters">
								<ul id="current-refinements-mobile" class="search-header-active-filters"></ul>
								<div class="ais-clear-refinements-container ais-clear-refinements-container-mobile"></div>
							</div>

							<div class="ais-facets search-filters">
								<div class="ais-sort">
									${data.multipleSortOrders ? html`
										<span class="ais-sort-label">${window.algoliaLocales.sort_by}</span>
										<span class="ais-sort-orders-container"></span>
									` : html`
										${window.algoliaLocales.sort_by}
										${window.algoliaLocales.sorting.relevance}
									`}
								</div>
								
								${data.facets.map(
								// ${algoliaShopify.facets.map(
									
									facet => {
										// Get filter type class based on facet name
										const filterTypeClass = FILTER_TYPE_MAP[facet.escapedName] || FILTER_TYPE_MAP['default'];

										const translationKey = FACET_TRANSLATION_MAP[facet.escapedName];
										const translatedTitle = window.algoliaLocales?.facets?.[translationKey];
										const facetTitle = translatedTitle || facet.title;

										return html`
											<details 
												open
												class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName} ${filterTypeClass}"
											>
												<summary>${facetTitle}</summary>
												<div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
											</details>
										`;
									}
								)}
							</div>
							
							<!-- Show Results Button (Mobile) -->
							<button class="show-results-btn show-results-button search-sidebar-close"></button>
						</div>
          			</div>
          
					<!-- Search Products -->
					<div class="search-products">
						<div class="ais-search-header" style="display: none;">
							<div class="ais-stats-container"></div>
							<div class="ais-change-display">
								<span class="ais-change-display-block ais-change-display-selected">
									<i class="fa fa-th-large"></i>
								</span>
								<span class="ais-change-display-list">
									<i class="fa fa-th-list"></i>
								</span>
							</div>
						</div>

						<div class="ais-hits-container ais-results-as-block"></div>
					<div class="ais-pagination-container"></div>
				</div>
				</div>
			</div>`;
	});

	algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
		// Please be aware not all widgets are available
		const { stats, clearRefinements, pagination } = window.algoliaShopify.externals.widgets;

		const customPagination = pagination({
			container: '.ais-pagination-container',
			scrollTo: document.querySelector('.pagination-scroll-anchor'),
			padding: 1,
			templates: {
				first() {
					return '‹‹';
				},
				previous() {
					return '‹';
				},
				next() {
					return '›';
				},
				last() {
					return '››';
				}
			},
		});

		const resultsCountInButton = stats({
			container: '.show-results-button',
			templates: {
				text(data, { html }) {
					return html`${window.algoliaLocales.show_results.replace('[count]', data.nbHits)}`;
				},
			},
		});

		// Recent searches are recorded here rather than on page load, because this is the
		// first point at which the hit count is known — see the note in algolia-quick-search.js.
		// stats re-renders on every refinement, so the guard keeps a facet change from
		// re-saving (and reshuffling) a query already captured this pageview.
		let capturedRecentQuery = null;

		function captureRecentSearch(nbHits) {
			const store = window.dpdRecentSearches;
			if (!store) return;

			const query = (new URLSearchParams(window.location.search).get('q') || '').trim();
			if (!query || query === capturedRecentQuery) return;
			if (nbHits < store.minHits) return;

			capturedRecentQuery = query;
			store.save(query);
		}

		let searchCount;
		if (window.isSearchTemplate) {
			searchCount = stats({
				container: '.search-count',
				templates: {
					text(data, { html }) {
						captureRecentSearch(data.nbHits);
						return html`(${window.algoliaLocales.search_products.replace('[count]', data.nbHits)})`;
					},
				},
			});
		}

		const resultsCountInTitle = stats({
			container: '.search-sidebar-title__results-count',
			templates: {
				text(data, { html }) {
					return html`${window.algoliaLocales.results_count_html.replace('[count]', data.nbHits)}`;
				},
			},
		});

		const sidebarToggle = {
			init: () => {
				const filterToggle = document.querySelector('.filter-sort-toggle');
				const layout = document.querySelector('.algolia-custom-layout');
				const searchSidebar = document.querySelector('.search-sidebar');
				const closeButtons = document.querySelectorAll('.search-sidebar-close');

				// Restore sidebar state from localStorage
				const savedSidebarState = localStorage.getItem('algolia-sidebar-open') || 'true';
				const shouldOpenSidebar = savedSidebarState === 'true';

				if (filterToggle && layout) {
					// Apply saved state on initialization
					calculateHeaderHeight();

					if (shouldOpenSidebar && window.innerWidth > 1023) {
						layout.classList.add('sidebar-open');
						searchSidebar.inert = false;
					}

					setTimeout(() => {
						layout.classList.remove('layout-switching');
					}, 300);

					filterToggle.addEventListener('click', (e) => {
						e.preventDefault();

						const isOpen = layout.classList.contains('sidebar-open');
						
						// Save state to localStorage
						localStorage.setItem('algolia-sidebar-open', !isOpen);
						
						// Use the 3-phase animation system
						if (window.threePhaseAnimator) {
							window.threePhaseAnimator.animateSidebarToggle();
						} else {
							// Fallback to simple toggle
							if (!isOpen) {
								layout.classList.add('sidebar-open');
								searchSidebar.inert = false;

								calculateHeaderHeight();
								if (window.innerWidth < 768) {
									document.body.style.overflowY = 'hidden';
								}
							} else {
								layout.classList.remove('sidebar-open');
								searchSidebar.inert = true;
								document.body.style.overflowY = 'auto';
							}
						}
					});
				}

				// Close buttons
				closeButtons.forEach(button => {
					button.addEventListener('click', (e) => {
						e.preventDefault();
						
						const isOpen = layout.classList.contains('sidebar-open');
						if (isOpen) {
							// Save closed state to localStorage
							localStorage.setItem('algolia-sidebar-open', 'false');
							
							// Use the 3-phase animation system for closing
							if (window.threePhaseAnimator) {
								window.threePhaseAnimator.animateSidebarToggle();
							} else {
								// Fallback to simple close
								layout.classList.remove('sidebar-open');
								searchSidebar.inert = true;
								document.body.style.overflowY = 'auto';
							}
						}
					});
				});

				// Initialize grid layout (this one is correct - just sets initial columns)
				window.threePhaseAnimator?.updateGridLayout();
			}
		};

		/**
		 * Active Filters Counter Widget
		 * Counts all active refinements and displays the count in the filter toggle button
		 */
	
		const activeFiltersCounter = {
			init() {
				// Widget initialization
			},
			render({ results, helper }) {
				const badge = document.querySelector('.filter-count-badge');
				if (!badge) return;

				// Get all refinements 
				// console.log('activeFiltersCounter results', results);
				let allRefinements = results.disjunctiveFacets.map(e => helper.getRefinements(e.name));

				// console.log('activeFiltersCounter allRefinements', allRefinements);
				const totalCount = allRefinements.flat().length;

				// Update badge display
				if (totalCount > 0) {
					badge.textContent =  `(${totalCount})`;
					badge.style.display = 'flex';
				} else {
					badge.style.display = 'none';
				}
			}
		};

		const clearRefinementsTemplates = {
			resetLabel({ hasRefinements }, { html }) {
				// console.log('clearRefinementsTemplates', ...arguments);

				return html`${hasRefinements ? 'Clear' : null}`;
			}
		};
		// const clearRefinementsDesktop = clearRefinements({
		// 	container: '.ais-clear-refinements-container-desktop',
		// 	templates: clearRefinementsTemplates,
		// });

		const clearRefinementsMobile = clearRefinements({
			container: '.ais-clear-refinements-container-mobile',
			excludedAttributes: ['tags'],
			templates: clearRefinementsTemplates,
		});

		const activeFiltersWrapper = document.querySelector('.search-header-bottom');
		// const activeFiltersContainer = document.querySelector('#current-refinements');
		const activeFiltersContainerMobile = document.querySelector('#current-refinements-mobile');

		const createDataAttribtues = refinement =>
			Object.keys(refinement)
				.map(key => `data-${key}="${refinement[key]}"`)
				.join(' ');

		const renderListItem = (item, algoliaLocales) => {

			// console.log('🔍 renderListItem', item);

			return item.refinements.map((refinement) => {
				let label = refinement.label;
				let value = refinement.value;
		

				if (refinement.attribute === 'tags') {
					return `
					`;
				}

				if (refinement.attribute === 'price') {
					label = `${algoliaLocales.price_prefix} ${refinement.operator} ${value} CAD`;
				}

				// Special handling for availability
				if (refinement.attribute === 'inventory_available') {
					if (value === 'true') {
						label = algoliaLocales.in_stock;
					} else if (value === 'false') {
						label = algoliaLocales.out_of_stock;
					}
				}

				// Special handling for size
				if (refinement.attribute === 'options.size' || refinement.attribute === 'meta.custom.variant_size_grouping_filter') {
					label = `${algoliaLocales.size_prefix} ${label}`;
				}

				if (
					refinement.attribute === 'meta.custom.categories_filter' 
					|| refinement.attribute === 'meta.custom.subcategories_filter'
					|| refinement.attribute === 'meta.custom.genders_filter'
					|| refinement.attribute === 'meta.custom.seasons_filter'
				) {
					label = getTranslatedLabel(label, refinement.attribute);
				}
	  
				return `
						<li>
							<button ${createDataAttribtues(refinement)}>
								<span>
								  ${label}
								</span>
								<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
									<line x1="18" y1="6" x2="6" y2="18" stroke-width="2"></line>
									<line x1="6" y1="6" x2="18" y2="18" stroke-width="2"></line>
								</svg>
							</button>
						</li>
					`;
			  }).join('');
		};

		const renderCurrentRefinements = (renderOptions, isFirstRender) => {
			const { items, refine, widgetParams } = renderOptions;

			const filteredItems = items;

			widgetParams.container.innerHTML = `
				${filteredItems.map(item => renderListItem(item, algoliaLocales)).join('')}
			`;

			if (filteredItems.length == 0) {
				activeFiltersWrapper.classList.add('empty');
			} else {
				activeFiltersWrapper.classList.remove('empty');
			}

			[...widgetParams.container.querySelectorAll('button')].forEach(element => {
				element.addEventListener('click', event => {
					const item = Object.keys(event.currentTarget.dataset).reduce(
						(acc, key) => ({
							...acc,
							[key]: event.currentTarget.dataset[key],
						}),
						{}
					);

					refine(item);
				});
			});
		};

		const { connectCurrentRefinements } = window.algoliaShopify.externals.connectors;
		// Create the custom widget
		const customCurrentRefinements = connectCurrentRefinements(
			renderCurrentRefinements
		);

		// Instantiate the custom widget
		// const appliedFilters = customCurrentRefinements({
		// 	container: activeFiltersContainer,
		// });

		const appliedFiltersMobile = customCurrentRefinements({
			container: activeFiltersContainerMobile,
		});
		
		const { refinementList } = window.algoliaShopify.externals.widgets;



	// Create a custom rating group filter using the 'refinementList' widget
	// Only create if container exists on the page to avoid errors
	let ratingGroupFilter = null;
	if (document.querySelector('.ais-facet-meta\\.custom\\.rating_group-container')) {
		ratingGroupFilter = refinementList({
			container: '.ais-facet-meta\\.custom\\.rating_group-container',
			attribute: 'meta.custom.rating_group',
			transformItems: function(items) {
				// Sort items from highest rating to lowest and add " stars" to labels
				return items.sort((a, b) => {
					// Extract first number from range (e.g., "4.5 - 5" -> 4.5, "4 - 4.5" -> 4)
					const getFirstNumber = (label) => {
						const match = label.match(/^(\d+(?:\.\d+)?)/);
						return match ? parseFloat(match[1]) : 0;
					};
					return getFirstNumber(b.label) - getFirstNumber(a.label);
				}).map(item => {
					let ratingValue = 1; // default

					// Map ranges to star ratings for visual display
					if (item.label === '4.5 - 5') {
						ratingValue = 5;
					} else if (item.label === '4 - 4.5') {
						ratingValue = 4.5;
					} else if (item.label === '3 - 4') {
						ratingValue = 4;
					} else if (item.label === '2 - 3') {
						ratingValue = 3;
					} else if (item.label === '1 - 2') {
						ratingValue = 2;
					}

					return {
						...item,
						label: item.label + ' stars',
						ratingValue: ratingValue
					};
				});
			},
			templates: {
				item(item, { html }) {
					return html`
						<a
							href="${item.url}"
							class="ais-RefinementList-link ${item.isRefined ? 'is-active' : ''}"
						>
							<span class="ais-RefinementList-label">
								<span class="ais-RefinementList-stars">
									${renderRatingStars(item.ratingValue, { html })}
								</span>
								<span class="ais-RefinementList-labelText">${item.label.replace('&amp;', '&')}</span>
								<span class="ais-RefinementList-count ais-facet--count-distinct">${item.count}</span>
							</span>
						</a>
					`;
				},
				list(options, { html }) {
					return html`<div class="ais-RefinementList-list--rating">${options.items}</div>`;
				}
			}
		});
	}

		const availabilityLinker = {
			_previousSizeState: false,
			_availabilityManuallyRemoved: false,

			init() {
				// This widget has no UI, it only hooks into the search lifecycle.
				// Store initial state
				this._previousSizeState = false;
				this._availabilityManuallyRemoved = false;
			},

			render({ helper }) {
				const sizeAttribute = 'meta.custom.variant_size_grouping_filter';
				const availabilityAttribute = 'inventory_available';
				const availabilityValue = 'true';

				const isSizeRefined = helper.state.isDisjunctiveFacetRefined(sizeAttribute);
				const isAvailabilityRefined = helper.state.isDisjunctiveFacetRefined(availabilityAttribute, availabilityValue);

				// Detect if size filter was just added (transition from false to true)
				const sizeJustAdded = !this._previousSizeState && isSizeRefined;
				
				// Detect if size filter was completely removed (transition from true to false)
				const sizeRemoved = this._previousSizeState && !isSizeRefined;

				// If size was just removed, reset the manual removal flag
				if (sizeRemoved) {
					this._availabilityManuallyRemoved = false;
					// Also remove availability when no size is selected
					if (isAvailabilityRefined) {
						helper.removeDisjunctiveFacetRefinement(availabilityAttribute, availabilityValue).search();
					}
				}
				// If size was just added and availability wasn't manually removed, add availability
				else if (sizeJustAdded && !this._availabilityManuallyRemoved) {
					if (!isAvailabilityRefined) {
						helper.addDisjunctiveFacetRefinement(availabilityAttribute, availabilityValue).search();
					}
				}
				// If size is selected but availability was removed (and it wasn't us who removed it in this render)
				else if (isSizeRefined && !isAvailabilityRefined && this._previousSizeState) {
					// User manually removed availability - remember this
					this._availabilityManuallyRemoved = true;
				}

				// Update previous state for next render
				this._previousSizeState = isSizeRefined;
			}
		};

		// --- Custom InstantSearch Widgets ---

		// Global state for category baseline counts
		window.__CATEGORY_BASELINE_SNAPSHOT__ = window.__CATEGORY_BASELINE_SNAPSHOT__ || null;
		window.__BASELINE_CAPTURED__ = window.__BASELINE_CAPTURED__ || false;

		// Initialize global state trackers for the category linker widget
		window.__LAST_CATEGORY_REFINEMENTS__ = window.__LAST_CATEGORY_REFINEMENTS__ || [];
		window.__CURRENT_ACTIVE_CATEGORY__ = window.__CURRENT_ACTIVE_CATEGORY__ || null;

		/**
		 * Custom widget to link Categories and Subcategories behavior.
		 * - Enforces single selection for categories.
		 * - Clears subcategory refinements when the active category changes.
		 */
		const categorySubcategoryLinker = {
			init() {},
			render({ results, helper }) {
				const categoriesAttribute = 'meta.custom.categories_filter';
				const subcategoriesAttribute = 'meta.custom.subcategories_filter';

				window.algoliaCustomData = {
					allRefinements: results.disjunctiveFacets.map(e => helper.getRefinements(e.name)),
					categoriesRefinements: helper.getRefinements(categoriesAttribute),
					subcategoriesRefinements: helper.getRefinements(subcategoriesAttribute),
					categoriesFacetData: results.getFacetValues(categoriesAttribute, {}),
					subcategoriesFacetData: results.getFacetValues(subcategoriesAttribute, {}),
				};

				// console.log('categorySubcategoryLinker algoliaCustomData', algoliaCustomData);

				// if any subcategories are selected without categories
				if(algoliaCustomData.subcategoriesRefinements.length > 0 
					&& algoliaCustomData.categoriesRefinements.length === 0
				) {
					// if more than one category is available, clear the subcategories
					const categoriesCheckboxes = document.querySelectorAll('.ais-facet-meta\\.custom\\.categories_filter input.ais-RefinementList-checkbox--category');
					// if (algoliaCustomData.categoriesFacetData.length === 1) {
					if (categoriesCheckboxes.length === 1) {
						helper.addDisjunctiveFacetRefinement(categoriesAttribute, algoliaCustomData.categoriesFacetData[0].escapedValue);	
					} else {
						helper.clearRefinements(subcategoriesAttribute)
					}
					
					helper.search();

					return;
				}


				const currentRefinements = helper.getRefinements(categoriesAttribute);

				// 1. Enforce single category selection
				if (currentRefinements.length > 1) {
					const lastRefinements = window.__LAST_CATEGORY_REFINEMENTS__;
					const newItem = currentRefinements.find(r => !lastRefinements.find(lr => lr.value === r.value));
					const categoryToKeep = newItem || currentRefinements[0]; // Fallback to first

					helper.clearRefinements(categoriesAttribute)
						.clearRefinements(subcategoriesAttribute)
						.addDisjunctiveFacetRefinement(categoriesAttribute, categoryToKeep.value)
						.search();

					return; // A new search is triggered, so we wait for re-render.
				}
				window.__LAST_CATEGORY_REFINEMENTS__ = currentRefinements;

				if (currentRefinements.length === 0) {
					// helper.clearRefinements(subcategoriesAttribute).search();
					// return;
				}

				// 2. Clear subcategories if the active category changes
				const activeCategory = currentRefinements.length === 1 ? currentRefinements[0] : null;
				if (window.__CURRENT_ACTIVE_CATEGORY__?.value !== activeCategory?.value) {
					if (helper.getRefinements(subcategoriesAttribute).length > 0 && algoliaCustomData.categoriesFacetData.length > 1) {
						window.__CURRENT_ACTIVE_CATEGORY__ = activeCategory;
						helper.clearRefinements(subcategoriesAttribute).search();
						return; // A new search is triggered, wait for re-render.
					}
				}
				window.__CURRENT_ACTIVE_CATEGORY__ = activeCategory;
					
			},
			dispose() {
				// Clean up global state if the widget is ever removed.
				delete window.__LAST_CATEGORY_REFINEMENTS__;
				delete window.__CURRENT_ACTIVE_CATEGORY__;
			}
		};


		const { configure } = window.algoliaShopify.externals.widgets;

		const configureFacetingAfterDistinct = configure({
			facetingAfterDistinct: false
		});

	// --- End Custom Widgets ---

	let results = [resultsCountInButton, resultsCountInTitle, sidebarToggle,
			activeFiltersCounter,
		 appliedFiltersMobile,
		 clearRefinementsMobile, customPagination,
		availabilityLinker,
		// ratingFilter,
		categorySubcategoryLinker,
		// initialLoadManager,
		configureFacetingAfterDistinct
	];

	// Add ratingGroupFilter only if it was created (container existed)
	if (ratingGroupFilter) {
		results.push(ratingGroupFilter);
	}

		if (window.isSearchTemplate) {
			results = [...results, searchCount];
		}

		return results;
	});

	algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
		// Find and return the default pagination widget
		const defaultStats = defaultWidgets.find(
			widget => widget.$$widgetType === "ais.stats"
		);

		return [defaultStats];
	});


	algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
		const sizeFacetNames = ['options.size', 'meta.custom.variant_size_grouping_filter'];


		// Customize the Categories filter to use baseline counts
		if (facet.escapedName === 'meta.custom.categories_filter') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  const translatedLabel = getTranslatedLabel(label, facet.escapedName);
				
					  return html`
						<label class="ais-RefinementList-label category-facet-label ais-facet--label">
							<input type="checkbox" class="ais-RefinementList-checkbox ais-RefinementList-checkbox--category ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							<span class="ais-RefinementList-custom-label">${translatedLabel}</span>
							<span class="ais-RefinementList-count ais-facet--count-distinct">${count}</span>
						</label>
					  `;
					},
				},
				transformItems: function(items, { results }) {
					const categoriesAttribute = 'meta.custom.categories_filter';
					const subcategoriesAttribute = 'meta.custom.subcategories_filter';

					// debugger;

					const state = results._state;
					const isSubcategoryRefined = state.disjunctiveFacetsRefinements[subcategoriesAttribute]?.length > 0;

					// If no subcategory is refined, the live items are correct.
					// This is the moment to update our cache.
					if (!isSubcategoryRefined) {
						window.__CATEGORY_BASELINE_SNAPSHOT__ = items.map(item => ({ ...item }));
						window.__BASELINE_CAPTURED__ = true;
						return items; // Return live, sorted items
					}

					// If a subcategory IS refined, we use the cached baseline to ensure all categories are shown.
					if (window.__BASELINE_CAPTURED__) {
						const masterList = window.__CATEGORY_BASELINE_SNAPSHOT__;
						const liveRefinedValue = items.find(i => i.isRefined)?.value;

						const transformedItems = masterList.map(baselineItem => {
							const isRefined = baselineItem.value === liveRefinedValue;

							return {
								...baselineItem,
								isRefined: isRefined,
								count: baselineItem.count, // Use the baseline count
								cssClasses: {
									...baselineItem.cssClasses,
									count: baselineItem.cssClasses?.count
								}
							};
						});

						return transformedItems;
					}

					// Fallback: return original items if no baseline is available yet.
					return items;
				}
			};
		}

		// Show all subcategories and hide "show more"
		if (facet.escapedName === 'meta.custom.subcategories_filter') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc'],
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;
					  const translatedLabel = getTranslatedLabel(label, facet.escapedName);
				
					  return html`
						<label class="ais-RefinementList-label ais-facet--label">
							<input type="checkbox" data-subcategory-facet-label="${label}" class="ais-RefinementList-checkbox ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							<span class="ais-RefinementList-custom-label">${translatedLabel}</span>
							<span class="ais-RefinementList-count ais-facet--count-distinct">${count}</span>
						</label>
					  `;
					},
				}
			};
		}
		
		// Filter out or hide "unisex" gender filters
		if (facet.escapedName === 'meta.custom.genders_filter') {
			return {
				...params,
				transformItems(items) {
					return items.filter((item) => {
						console.log('Gender item', item);
					  return !item.label.toLowerCase().includes('unisex');
					});
				  },
			};
		}
	
		// sort discount percentages and rating groups
		if (facet.escapedName === 'meta.custom.discount_percentage' || facet.escapedName === 'meta.custom.discount_percentage_usa') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:asc']
			};
		}
		if (facet.escapedName === 'meta.custom.rating_group') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				sortBy: ['name:desc']
			};
		}
	
		// Customize the Size filter
		if (sizeFacetNames.includes(facet.escapedName)) {
			return {
				...params,
				limit: 100, // Show all sizes
				showMore: false, // Disable the "Show more" button
				transformItems: function(items) {
					const months = [];
					const numbers = [];
	
					// Separate items into month-based and numeric sizes
					items.forEach(item => {
						if (item.label.toLowerCase().endsWith('m')) {
							months.push(item);
						} else {
							numbers.push(item);
						}
					});
	
					// Sort month-based sizes numerically
					months.sort((a, b) => {
						const numA = parseInt(a.label.replace(/m/i, ''), 10);
						const numB = parseInt(b.label.replace(/m/i, ''), 10);
						return numA - numB;
					});
	
					// Sort numeric sizes numerically
					numbers.sort((a, b) => {
						const numA = parseInt(a.label, 10);
						const numB = parseInt(b.label, 10);
						return numA - numB;
					});
	
					// Combine the sorted lists
					return [...months, ...numbers];
				}
			};
		}
		
		// Customize the Availability filter
		if (facet.escapedName === 'inventory_available') {
			return {
				...params,
				sortBy: ['name:desc'],
				templates: {
					item(item, { html }) {
					  	const { url, label, count, isRefined } = item;

						// debugger;

						// Only render if this is the 'In Stock' option
						if (item.value === 'true') {
							return html`
								<div class="inventory-toggle-wrapper">
									<label class="toggle-switch">
										<input type="checkbox" class="ais-RefinementList-checkbox inventory-toggle-checkbox ${isRefined ? "toggle--checked" : ""}" ${isRefined ? "checked" : ""}/>
										<span class="toggle-indicator"></span>
										<span class="toggle-label">${window.algoliaLocales.in_stock}</span>
									</label>
									<span class="ais-RefinementList-count inventory-toggle-count">${count}</span>
								</div>
							`;
						}
						
						// Don't render anything for 'Out of Stock'
						return '';
					},
					
				},
			};
		}

		if (facet.escapedName === 'meta.custom.color_group') {
			return {
				...params,
				limit: 1000,
				showMore: false,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;

						return html`
							<label 
								class="ais-RefinementList-label ais-facet--label ${'white, beige'.split(', ').includes(item.label.toLowerCase()) ? 'white-color' : ''}" 
								style="
									${item.label.toLowerCase() == 'multicolored' 
										// rainbow gradient
									? `background-image: linear-gradient(to right, #ff0000, #ffa500, #ffff00, #00ff00, #0000ff, #8b00ff);` 
									: `background-color: ${item.label.toLowerCase()};`}
								
								"
							>
								<input type="checkbox" class="ais-RefinementList-checkbox ais-facet--checkbox ${isRefined ? 'checked' : ''}" ${isRefined ? 'checked' : ''} />
							</label>
							<span class="ais-RefinementList-count ais-facet--count-distinct">${item.count}</span>
						`;
					}
				}
			}
		}
		
		if (facet.type == "disjunctive" || facet.type == "conjunctive") {
			// console.log('beforeInstantSearchFacetParamsOptions arguments', ...arguments);

			return {
				...params,
				limit: 12,
				showMoreLimit: 1000,
				showMore: true,
				templates: {
					item(item, { html }) {
						const { url, label, count, isRefined } = item;
				  
						return html`
						<label class="LOOOL ${item.cssClasses.label}">
							${(item.isRefined ? html`
									<input
										type="checkbox"
										class="lol ${item.cssClasses.checkbox}"
										checked
									/>
									` : html`
									<input type="checkbox" class="${item.cssClasses.checkbox}" />
									`)}
									
							${getTranslatedLabel(item.label, facet.escapedName)}
							<span class="${item.cssClasses.count}">
								${item.count}
							</span>
						</label>
						`;
					}
				}
			}
		}

		return {
			...params
		}
	});
});


/**
 * Updates JSON-LD structured data with current Algolia hits
 * Only runs on collection and search templates
 */
function updateJsonLdStructuredData() {
	// Check if we're on collection or search template
	const isCollectionPage = document.body?.dataset?.template === 'collection' ||
	                        document.body.classList.contains('template-collection');
	const isSearchPage = document.body?.dataset?.template === 'search' ||
	                    document.body.classList.contains('template-search');

	if (!isCollectionPage && !isSearchPage) return;

	// Create or update JSON-LD script
	const jsonLdScriptId = isCollectionPage ? 'algolia-collection-jsonld' : 'algolia-search-jsonld';
	let jsonLdScript = document.getElementById(jsonLdScriptId);

	// Get current hits from the DOM (Algolia product cards)
	const productCards = document.querySelectorAll('.ais-hits-container .ais-product');
	const itemListElement = [];

	productCards.forEach((card, index) => {
		const productUrl = card.querySelector('a')?.href;

		// Get primary image URL from the card
		const primaryImage = card.querySelector('.product-card__image');
		let imageUrl = '';

		if (primaryImage) {
			// Try to get the src, fallback to data-src for lazy loaded images
			imageUrl = primaryImage.src || primaryImage.dataset.src || '';

			// Ensure we have an absolute URL
			if (imageUrl && !imageUrl.startsWith('http')) {
				imageUrl = window.location.origin + imageUrl;
			}
		}

		if (productUrl && imageUrl) {
			itemListElement.push({
				'@type': 'ListItem',
				'position': index + 1,
				'url': productUrl,
				'image': imageUrl
			});
		}
	});

	// Build the complete JSON-LD schema
	const schema = {
		'@context': 'https://schema.org',
		'@type': isCollectionPage ? 'CollectionPage' : 'SearchResultsPage',
		'name': isCollectionPage ?
			(document.querySelector('h1')?.textContent || 'Collection') :
			(window.algoliaLocales?.search_results_for || 'Search Results'),
		'url': window.location.href,
		'mainEntity': {
			'@type': 'ItemList',
			'itemListElement': itemListElement
		}
	};

	// Add collection-specific properties if on collection page
	if (isCollectionPage) {
		const collectionTitle = document.querySelector('h1')?.textContent || 'Collection';
		const collectionDescription = document.querySelector('.collection-description')?.textContent;

		schema.name = collectionTitle;

		if (collectionDescription) {
			schema.description = collectionDescription;
		}

		// Try to get collection image if available
		const collectionImage = document.querySelector('.collection-hero__image img');
		if (collectionImage) {
			let collectionImageUrl = collectionImage.src || collectionImage.dataset.src || '';
			if (collectionImageUrl && !collectionImageUrl.startsWith('http')) {
				collectionImageUrl = window.location.origin + collectionImageUrl;
			}
			if (collectionImageUrl) {
				schema.primaryImageOfPage = {
					'@type': 'ImageObject',
					'url': collectionImageUrl
				};
			}
		}
	}

	// Add search-specific properties if on search page
	if (isSearchPage) {
		const searchQuery = new URLSearchParams(window.location.search).get('q');
		if (searchQuery) {
			schema.query = searchQuery;
		}
	}

	// Create or update the JSON-LD script
	const schemaString = JSON.stringify(schema, null, 2);

	if (jsonLdScript) {
		// Update existing script
		jsonLdScript.textContent = schemaString;
	} else {
		// Create new script
		jsonLdScript = document.createElement('script');
		jsonLdScript.type = 'application/ld+json';
		jsonLdScript.id = jsonLdScriptId;
		jsonLdScript.textContent = schemaString;

		// Insert at the end of head or beginning of body
		const target = document.head || document.body;
		target.appendChild(jsonLdScript);
	}
}

  


let sortBySyncInitialized = false;
let isFirstRender = true;
let filtersAttached = false;
let previousRefinementsCount = 0;
let sidebarWasOpen = false;
let stickyScrollListenerAttached = false;

/**
 * Scroll page to the top of the products grid
 */
function scrollToProductsGrid() {
	const algoliaSection = document.getElementById('algolia-shopify-instantsearch');
	if (!algoliaSection) return;

	// Get the products grid
	const productsGrid = algoliaSection.querySelector('.ais-hits-container');
	if (!productsGrid) return;

	// Get sticky header heights from actual elements and CSS variables
	const header = document.querySelector('sticky-header.header');
	const collectionHeader = document.querySelector('.collection-banner');
	
	let headerHeight = 0;
	let collectionHeaderHeight = 0;
	
	// Try to get height from CSS variable first, fallback to offsetHeight
	if (header) {
		const cssHeaderHeight = getComputedStyle(document.documentElement)
			.getPropertyValue('--header-height');
		headerHeight = cssHeaderHeight ? parseFloat(cssHeaderHeight) : header.offsetHeight;
	}
	
	if (collectionHeader) {
		collectionHeaderHeight = collectionHeader.offsetHeight;
	}
	
	// Check if products grid is already visible in viewport
	const gridRect = productsGrid.getBoundingClientRect();
	const totalHeaderHeight = headerHeight + collectionHeaderHeight;
	const isGridVisible = gridRect.top >= totalHeaderHeight && gridRect.top < window.innerHeight;
	
	// Only scroll if grid is not visible or is above the fold
	if (!isGridVisible || gridRect.top < totalHeaderHeight) {
		// Calculate scroll position: section top - sticky headers
		const sectionTop = algoliaSection.getBoundingClientRect().top + window.scrollY;
		const scrollTarget = sectionTop - headerHeight - collectionHeaderHeight;
		
		// Smooth scroll to target
		window.scrollTo({
			top: Math.max(0, scrollTarget),
			behavior: 'smooth'
		});
	} else {
	}
}

/**
 * Restore sidebar scroll position to last interacted filter
 */
function restoreSidebarScroll() {
	const sidebar = document.querySelector('.search-sidebar');
	if (!sidebar) return;

	const lastFilterSelector = localStorage.getItem('algoliaLastFilterSelector');
	if (!lastFilterSelector) return;

	// Find the last clicked filter element
	const lastFilter = sidebar.querySelector(lastFilterSelector);
	if (!lastFilter) {
		localStorage.removeItem('algoliaLastFilterSelector');
		return;
	}

	// Check if we're on mobile (sidebar is fixed fullscreen) or desktop (sidebar is sticky)
	const isMobile = window.innerWidth < 1024;
	
	// Get the filter's position relative to sidebar
	const sidebarRect = sidebar.getBoundingClientRect();
	const filterRect = lastFilter.getBoundingClientRect();
	
	// Calculate how much to scroll to keep filter in view
	// Aim to position it ~100px from top of sidebar for better visibility (or ~20px on mobile)
	const targetOffset = isMobile ? 150 : 100;
	const currentOffset = filterRect.top - sidebarRect.top + sidebar.scrollTop;
	const scrollTarget = currentOffset - targetOffset;
	
	// Only scroll if the filter is not already in the visible area
	const isFilterVisible = filterRect.top >= sidebarRect.top && 
	                        filterRect.bottom <= sidebarRect.bottom;
	
	if (!isFilterVisible && scrollTarget >= 0) {
		sidebar.scrollTo({
			top: scrollTarget,
			behavior: 'smooth'
		});
	}
}

/**
 * Attach click listeners to filter elements to track user interaction
 */
function attachFilterClickListeners() {
	if (filtersAttached) return;
	
	const sidebar = document.querySelector('.search-sidebar');
	if (!sidebar) return;

	// Listen for clicks on filter checkboxes and labels
	sidebar.addEventListener('click', (e) => {
		const checkbox = e.target.closest('input[type="checkbox"]');
		const label = e.target.closest('.ais-RefinementList-label, .ais-RefinementList-labelText');
		const clearButton = e.target.closest('.ais-ClearRefinements-button, .ais-RefinementList-showMore');
		const removeRefinement = e.target.closest('.ais-CurrentRefinements-delete, #current-refinements-mobile .search-header-active-filter');
		
		if (checkbox || label) {
			// Find the parent details element to save its selector
			const detailsWrapper = e.target.closest('details.ais-facet-dropdown-wrapper');
			if (detailsWrapper) {
				// Create a unique selector based on the facet class
				const facetClasses = Array.from(detailsWrapper.classList)
					.filter(cls => cls.startsWith('ais-facet-'))
					.join('.');
				
				if (facetClasses) {
					const selector = `details.${facetClasses}`;
					localStorage.setItem('algoliaLastFilterSelector', selector);
				}
			}
		} else if (clearButton || removeRefinement) {
			// Don't clear the saved filter when removing individual refinements
			// Only clear when "Clear all" is clicked
			if (clearButton && e.target.closest('.ais-ClearRefinements-button')) {
				localStorage.removeItem('algoliaLastFilterSelector');
			}
		}
	});

	filtersAttached = true;
}

document.addEventListener('algolia.instantSearch.onRender', function (e) {

	// Attach filter listeners on first render
	if (isFirstRender) {
		attachFilterClickListeners();
	}

	// Check if sidebar state changed (opened/closed)
	const layout = document.querySelector('.algolia-custom-layout');
	const sidebarIsOpen = layout ? layout.classList.contains('sidebar-open') : false;
	const sidebarStateChanged = sidebarIsOpen !== sidebarWasOpen;

	// Count current active refinements to detect changes
	const currentRefinementsCount = (() => {
		const allRefinements = document.querySelectorAll('.ais-RefinementList-item--selected, .ais-CurrentRefinements-item');
		return allRefinements.length;
	})();

	// Detect if refinements actually changed (not just re-render from sort/pagination/sidebar toggle)
	const refinementsChanged = !isFirstRender && 
	                          currentRefinementsCount !== previousRefinementsCount &&
	                          !sidebarStateChanged;

	// Handle scroll restoration after filter changes (not on first render, only when refinements change)
	if (refinementsChanged) {
		scrollToProductsGrid();
		
		// Restore sidebar scroll after a short delay to ensure DOM is updated
		setTimeout(() => {
			restoreSidebarScroll();
		}, 150);
	}

	// Update tracking variables
	previousRefinementsCount = currentRefinementsCount;
	sidebarWasOpen = sidebarIsOpen;
	
	// Mark that we've completed first render
	if (isFirstRender) {
		isFirstRender = false;
	}

	/**
	 * Simplified Sorting Logic
	 * 1. If URL sortBy is valid → do nothing (Algolia handles it)
	 * 2. If URL sortBy is invalid → find valid option with same suffix and apply
	 * 3. If no URL sortBy → apply collection metafield default (if not applied yet)
	 */
	if (!sortBySyncInitialized) {
		// Clean up old storage data (migration)
		localStorage.removeItem('algoliaPageSorting');
		localStorage.removeItem('algoliaCurrentContext');
		
		// Clean up old sessionStorage key format (if exists)
		const oldKeys = Object.keys(sessionStorage).filter(key => key.startsWith('customDefaultApplied_'));
		oldKeys.forEach(key => sessionStorage.removeItem(key));

		const sortBySelect = document.querySelector('.ais-SortBy-select');

		if (sortBySelect) {
			// Get collection handle for sessionStorage key
			let collectionHandle = null;
			if (document.body.classList.contains('template-collection')) {
				const pathParts = window.location.pathname.split('/').filter(Boolean);
				const collectionsIndex = pathParts.indexOf('collections');
				if (collectionsIndex >= 0 && pathParts.length > collectionsIndex + 1) {
					collectionHandle = pathParts[collectionsIndex + 1];
				}
			}

			const urlParams = new URLSearchParams(window.location.search);
			const sortByParam = urlParams.get('sortBy');

			// All possible sorting suffixes (language/market agnostic)
			const sortingSuffixes = [
				'published_at_desc',
				'published_at_asc',
				'title_asc',
				'title_desc',
				'price_asc',
				'price_desc',
				'recently_ordered_count_desc'
			];

			// ========================================
			// Case 1: URL parameter exists
			// ========================================
			if (sortByParam) {
				// Check if URL parameter is valid (exact match in options)
				const exactMatch = sortBySelect.querySelector(`option[value="${sortByParam}"]`);
				
				if (exactMatch) {
					// Valid URL parameter - do nothing, Algolia handles it
				} else {
					// Invalid URL parameter - find valid option with same suffix
					const suffix = sortingSuffixes.find(s => sortByParam.includes(s));
					if (suffix) {
						const validOption = sortBySelect.querySelector(`option[value*="${suffix}"]`);
						if (validOption) {
							const targetIndex = Array.from(sortBySelect.options).indexOf(validOption);
							sortBySelect.selectedIndex = targetIndex;
							sortBySelect.dispatchEvent(new Event('change'));
						}
					}
				}
			}
			// ========================================
			// Case 2: No URL parameter - check metafield default
			// No URL parameter means default Relevance sorting is active
			// ========================================
			else if (collectionHandle && window.custom_collection_sort_by) {
				// Check if user manually selected Relevance (first option)
				const userSelectedRelevance = sessionStorage.getItem(`userSelectedRelevance_${collectionHandle}`) === 'true';
				
				if (!userSelectedRelevance) {
					// User hasn't manually selected Relevance - apply metafield default
					const defaultSuffix = window.custom_collection_sort_by;
					if (sortingSuffixes.includes(defaultSuffix)) {
						const matchingOption = sortBySelect.querySelector(`option[value*="${defaultSuffix}"]`);
						if (matchingOption) {
							const targetIndex = Array.from(sortBySelect.options).indexOf(matchingOption);
							sortBySelect.selectedIndex = targetIndex;
							sortBySelect.dispatchEvent(new Event('change'));
						}
					}
				}
			}

			// ========================================
			// Listen for manual sorting changes
			// Track when user manually selects Relevance (first option)
			// ========================================
			if (collectionHandle) {
				sortBySelect.addEventListener('change', () => {
					const selectedValue = sortBySelect.value;
					const selectedIndex = sortBySelect.selectedIndex;
					
					// Check if user selected the first option (Relevance)
					// Relevance option doesn't contain any sorting suffix
					const hasAnySuffix = sortingSuffixes.some(suffix => selectedValue.includes(suffix));
					
					if (selectedIndex === 0 || !hasAnySuffix) {
						// User manually selected Relevance (first option without suffix)
						sessionStorage.setItem(`userSelectedRelevance_${collectionHandle}`, 'true');
					} else {
						// User selected any other sorting option
						// Clear the flag so metafield can be applied again when returning to no sortBy param
						sessionStorage.removeItem(`userSelectedRelevance_${collectionHandle}`);
					}
				});
			}

			sortBySyncInitialized = true;
		}
	}

	// Setup sticky detection for algolia container
	const algoliaElement = document.getElementById('algolia-shopify-instantsearch');
	if (algoliaElement) {
		function checkStickyState() {
			const rect = algoliaElement.getBoundingClientRect();
			// Add class only when element's top edge is above viewport top
			if (rect.top < 0) {
				algoliaElement.classList.add('sticky-at-top');
			} else {
				algoliaElement.classList.remove('sticky-at-top');
			}
		}

		// Re-evaluate after this render's DOM has been laid out. Running it now
		// (before Algolia finishes inserting content) can latch the class on from
		// a transient early-load layout; deferring to the next frame clears it
		// automatically once content settles, without waiting for a scroll.
		requestAnimationFrame(checkStickyState);

		// Attach the scroll listener only once (onRender fires on every render).
		if (!stickyScrollListenerAttached) {
			let ticking = false;
			window.addEventListener('scroll', function() {
				if (!ticking) {
					requestAnimationFrame(function() {
						checkStickyState();
						ticking = false;
					});
					ticking = true;
				}
			}, { passive: true });
			stickyScrollListenerAttached = true;
		}
	}

	// sync collection count with the algolia results count
	const collectionCount = document.querySelector('[data-shopify-results-count]');
	const algoliaResultsCount = document.querySelector('[data-algolia-results-count]');
	if (collectionCount && algoliaResultsCount) {
		collectionCount.textContent = algoliaResultsCount.textContent;
	}

	// update page title on search pages to use algolia results count
	if (document.body.classList.contains('template-search') && algoliaResultsCount) {
		const currentTitle = document.title;
		const algoliaCount = algoliaResultsCount.textContent;

		// Replace any number in the title with the algolia count
		// This handles titles like "Search: 5 results for 'shirt'" -> "Search: 25 results for 'shirt'"
		const updatedTitle = currentTitle.replace(/\d+/, algoliaCount);

		if (updatedTitle !== currentTitle) {
			document.title = updatedTitle;
			// console.log('🔍 Updated search page title with Algolia results count:', updatedTitle);
		}
	}

	// === Merge Categories and Subcategories facets (Clone & Re-wire approach) ===
	(function mergeCatsSubs() {
		const categoriesWrapper = document.querySelector('details.ais-facet-meta\\.custom\\.categories_filter');
		const subcatsWrapper = document.querySelector('details.ais-facet-meta\\.custom\\.subcategories_filter');
		if (!categoriesWrapper || !subcatsWrapper) return;
		
		// Always hide the standalone subcategories facet in the sidebar UI
		if (!subcatsWrapper.classList.contains('is-merged-hidden')) {
			subcatsWrapper.classList.add('is-merged-hidden');
		}

		const originalSubcatsContainer = subcatsWrapper.querySelector('.ais-facet-meta\\.custom\\.subcategories_filter-container .ais-RefinementList');
		if (!originalSubcatsContainer) return;

		const categoriesList = categoriesWrapper.querySelector('.ais-RefinementList');
		if (!categoriesList) return;

		// const allCurrentRefinements = window.algoliaCustomData.allRefinements;
		// const currentRefinementsCategories = window.algoliaCustomData.categoriesRefinements;
		// const currentRefinementsSubcategories = window.algoliaCustomData.subcategoriesRefinements;
		const categoriesFacetData = window.algoliaCustomData.categoriesFacetData;
		// const subcategoriesFacetData = window.algoliaCustomData.subcategoriesFacetData;

		let activeCategoryItem = categoriesList.querySelector('.ais-RefinementList-item--selected');

		if(!activeCategoryItem && categoriesFacetData.length === 1) {
			activeCategoryItem = categoriesList.querySelectorAll(`.ais-RefinementList-item`)[0];
		}
		
		// Clone and place the subcategory list
		const existingSlot = categoriesList.querySelector('.merged-subcategories-slot');
		if (existingSlot) {
			existingSlot.remove();
		}

		if (activeCategoryItem) {
			// Create a slot to hold the cloned list
			const slot = document.createElement('div');
			slot.className = 'merged-subcategories-slot';
			
			const clonedSubcats = originalSubcatsContainer.cloneNode(true);
			slot.appendChild(clonedSubcats);
			activeCategoryItem.appendChild(slot);
			// Re-wire events from the clone to the original
			const originalInputs = originalSubcatsContainer.querySelectorAll('input[type="checkbox"]');
			const clonedInputs = clonedSubcats.querySelectorAll('input[type="checkbox"]');
			clonedInputs.forEach(clonedInput => {
				clonedInput.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					// Find the original input that corresponds to this clone and click it
					const originalInput = Array.from(originalInputs).find(input => input.dataset.subcategoryFacetLabel === clonedInput.dataset.subcategoryFacetLabel);
					if (originalInput) {
						originalInput.click();
					}
				});
			});
		}
	})();

	calculateHeaderHeight();

	// Update JSON-LD structured data with current Algolia hits
	updateJsonLdStructuredData();

	// Use the global helper to fetch additional data
	if (window.algoliaProductHelpers) {
		window.algoliaProductHelpers.fetchAdditionalProductData('.ais-hits-container');
	}

	const algoliaProductsRendered = document.querySelector('.ais-hits-container.ais-results-as-block');
	if (algoliaProductsRendered?.children?.length > 0) {
		hidePlaceholder();
	}

	// Set dynamic currency symbol for price facets
	// if (window.Shopify && Shopify.currency && Shopify.currency.active) {
	// 	const currencySymbol = Shopify.currency.active === 'USD' ? '$' :
	// 	                      Shopify.currency.active === 'EUR' ? '€' :
	// 	                      Shopify.currency.active === 'GBP' ? '£' :
	// 	                      Shopify.currency.active === 'CAD' ? 'CAD' :
	// 	                      Shopify.currency.active === 'JPY' ? '¥' :
	// 	                      Shopify.currency.active;

	// 	document.documentElement.style.setProperty('--currency-symbol', `'${currencySymbol}'`);
	// }

	// rename "Relevance" sorting option to "Best sellers"
	const relevanceOption = document.querySelector('.ais-SortBy-select option:first-child');
	if (relevanceOption && relevanceOption?.textContent == 'Relevance') {
		relevanceOption.textContent = window.algoliaLocales.sorting.relevance;
	}



	if (window.klaviyo_bis_base_config.show_in_product_cards) {
		window.resetKlaviyoBIS();
	}

	// start custom metaobject promo card 
	(function insertAlgoliaMetaobjectPromoCards() {
		const applicablePromos = getApplicableAlgoliaPromoCards();

		if (!applicablePromos.length) return;

		const algoliaSection = document.getElementById('algolia-shopify-instantsearch');
		if (!algoliaSection) return;

		const hitsContainer = algoliaSection.querySelector('.ais-hits-container');
		if (!hitsContainer) return;

		const hitsList = hitsContainer.querySelector('.ais-Hits-list');
		if (!hitsList) return;

		// Remove any existing promo cards to avoid duplicates on re-render
		hitsList.querySelectorAll('.ais-Hits-item--promo-card').forEach((node) => {
			if (node.parentNode === hitsList) {
				hitsList.removeChild(node);
			}
		});

		if (hitsList.children.length === 0) return;

		// Sort promos by desired card_position (1-based)
		const sortedPromos = applicablePromos
			.map((promo) => {
				const pos = parseInt(promo.card_position, 10);
				return {
					...promo,
					__position: Number.isNaN(pos) || pos < 1 ? 1 : pos
				};
			})
			.sort((a, b) => a.__position - b.__position);

		sortedPromos.forEach((promo) => {
			// debugger;

			const productCountOnPage = hitsList.children.length;

			// Not enough product cards on this page to place the promo at its intended index — skip
			if (productCountOnPage < promo.__position) {
				return;
			}

			// Clamp insertion index within current list bounds (should not clamp past end given check above)
			let insertIndex = promo.__position - 1;
			if (insertIndex > productCountOnPage) {
				insertIndex = productCountOnPage;
			}

			// Build promo card DOM
			const listItem = document.createElement('li');
			listItem.className = 'ais-Hits-item ais-Hits-item--promo-card';

			// Province tag. On the storefront getApplicableAlgoliaPromoCards() has
			// already dropped the non-matching variant, so this attribute is inert
			// there (the survivor always matches the group on <html>). It exists for
			// the theme editor, where no group is set: both variants get inserted and
			// the province switcher relies on CSS to show one at a time.
			if (promo.province === 'QC' || promo.province === 'ROC') {
				listItem.dataset.provinceSection = promo.province;
			}

			// Use <a> only when a link is provided, otherwise a non-interactive <div>
			
			const klaviyo_form_id_exists = promo.promo_klaviyo_form_id && promo.promo_klaviyo_form_id != '';
			const link = document.createElement(promo.promo_link && !klaviyo_form_id_exists ? 'a' : 'div');
			link.className = `algolia-promo-card ${klaviyo_form_id_exists ? 'algolia-promo-card--klaviyo' : ''}`;

			if (klaviyo_form_id_exists) {
				link.addEventListener('click', () => {
					window._klOnsite = window._klOnsite || []; 
					window._klOnsite.push(['openForm', promo.promo_klaviyo_form_id]);
				});
			} else if (promo.promo_link) {
				link.href = promo.promo_link;
				link.target = '_blank';
				link.rel = 'noopener noreferrer';
			}

			// Add style modifier based on text_button_style metafield (dark / light)
			const buttonStyle = (promo.text_button_style || '').toLowerCase();
			if (buttonStyle === 'light') {
				link.classList.add('algolia-promo-card--light');
			} else {
				link.classList.add('algolia-promo-card--dark');
			}

			// Optional per-card background; empty keeps the stylesheet default. Inline so it also wins over the :hover rules.
			if (promo.background_color) {
				link.style.backgroundColor = promo.background_color;
			}

			// Image
			if (promo.image) {
				const image = document.createElement('img');
				image.className = 'algolia-promo-card__image';
				image.src = promo.image;
				image.alt = promo.title || '';
				image.loading = 'lazy';
				link.appendChild(image);
			}

			// Content wrapper
			const content = document.createElement('div');
			content.className = 'algolia-promo-card__content';

			if (promo.title) {
				const titleEl = document.createElement('span');
				titleEl.className = 'algolia-promo-card__title';
				titleEl.textContent = promo.title;
				content.appendChild(titleEl);
			}

			if (promo.text_html) {
				const textWrapper = document.createElement('div');
				textWrapper.className = 'algolia-promo-card__text';
				textWrapper.innerHTML = promo.text_html;
				content.appendChild(textWrapper);
			}

			if (promo.button_text) {
				const buttonEl = document.createElement('span');
				buttonEl.className = 'algolia-promo-card__button';
				buttonEl.textContent = promo.button_text;
				content.appendChild(buttonEl);
			}

			link.appendChild(content);
			listItem.appendChild(link);

			const referenceNode = hitsList.children[insertIndex] || null;
			hitsList.insertBefore(listItem, referenceNode);
		});
	})();
	// end custom metaobject promo card
});

// Set up resize listener
const throttledCalculateHeaderHeight = throttle(calculateHeaderHeight, 300);
window.addEventListener('resize', throttledCalculateHeaderHeight);


/**
 * Algolia Loader Script
 * Handles the transition from placeholder to real Algolia content
 */

const algoliaPlaceholder = document.getElementById('algolia-placeholder');

/**
 * Wait until the async Algolia stylesheet (algolia-custom-styles.css — styles the
 * real filters + product grid) is APPLIED before swapping the skeleton for the real
 * content, so the real Algolia never flashes unstyled.
 *
 * FAILS OPEN: if the CSS is missing / slow / errors, we run the callback anyway after
 * a short timeout. The skeleton must NEVER get stuck because of a CSS/detection issue —
 * this is a best-effort validation gate, not a hard dependency. In practice Algolia's
 * own library + render finish AFTER the CSS, so this rarely delays the swap at all.
 */
function whenAlgoliaCssReady(done) {
	var TIMEOUT_MS = 1500;
	var POLL_MS = 50;
	var start = Date.now();

	function cssApplied() {
		try {
			var links = document.querySelectorAll('link[href*="algolia-custom-styles"]');
			// No matching link (inlined, or normal/render-blocking mode) → nothing to wait for.
			if (!links.length) return true;
			// link.sheet becomes non-null once the stylesheet has loaded & parsed.
			// (We deliberately do NOT touch .cssRules — that throws on cross-origin CDN sheets.)
			for (var i = 0; i < links.length; i++) {
				if (links[i].sheet) return true;
			}
			return false;
		} catch (e) {
			return true; // never let a detection error block the swap
		}
	}

	if (cssApplied()) { done(); return; }

	var iv = setInterval(function () {
		if (cssApplied() || (Date.now() - start) >= TIMEOUT_MS) {
			clearInterval(iv);
			done();
		}
	}, POLL_MS);
}

/**
 * Wait until QC/ROC province detection has settled, so the promo-card filter
 * runs once against a final answer instead of re-rendering the grid later.
 *
 * In practice this almost never delays anything: the group is set by Liquid for
 * non-CA markets, logged-in customers and returning visitors, and for everyone
 * else the worker request starts in <head>, long before Algolia has rendered.
 *
 * FAILS OPEN, same contract as whenAlgoliaCssReady: the skeleton must never get
 * stuck because detection is slow or broken.
 */
function whenProvinceReady(done) {
	var TIMEOUT_MS = 1500;
	var settled = false;
	function finish() {
		if (settled) return;
		settled = true;
		done();
	}
	try {
		var cfg = window.DPDProvince;
		if (!cfg || !cfg.enabled || cfg.resolved || !cfg.ready) { finish(); return; }
		setTimeout(finish, TIMEOUT_MS);
		cfg.ready.then(finish, finish);
	} catch (e) {
		finish();
	}
}

function hidePlaceholder() {
	if (!algoliaPlaceholder) return;

	whenProvinceReady(function () {
		whenAlgoliaCssReady(function () {
			document.body.classList.add('algolia-custom-loaded');

			// Remove placeholder from DOM after transition completes
			setTimeout(function () {
				if (algoliaPlaceholder && algoliaPlaceholder.parentNode) {
					algoliaPlaceholder.parentNode.removeChild(algoliaPlaceholder);
				}
			}, 500);
		});
	});
}
		


/**
	 * Renders a set of stars for a given rating.
	 * @param {number} rating - The rating value (e.g., 4, 5).
	 * @param {object} html - The html helper from Algolia.
	 * @returns {string} - The HTML string for the stars.
	 */
function renderRatingStars(rating, { html }) {
	return html`
		<div class="product-card__stars">
			${Array.from({ length: 5 }, (_, i) => {
				const isFullStar = i < Math.floor(rating);
				const isPartialStar = !isFullStar && i < Math.ceil(rating);
				const partialFill = isPartialStar ? (rating - Math.floor(rating)) * 100 : 0;

				return html`
					<div class="product-card__star-wrapper ${isFullStar ? 'product-card__star--active' : ''} ${isPartialStar ? 'product-card__star--partial' : ''}">
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="product-card__star">
							<path d="M9.44071 15.4206C9.16931 15.2561 8.829 15.2561 8.55761 15.4206L4.39532 17.9434C3.75017 18.3344 2.95263 17.7559 3.12406 17.0212L4.22755 12.2922C4.29924 11.985 4.19529 11.6633 3.95739 11.4561L0.293637 8.26557C-0.273874 7.77136 0.031211 6.83787 0.781053 6.77419L5.60934 6.36418C5.92375 6.33748 6.19766 6.13919 6.3212 5.84883L8.21605 1.39536C8.51015 0.704152 9.48985 0.704153 9.78395 1.39536L11.6788 5.84883C11.8023 6.13919 12.0762 6.33748 12.3907 6.36418L17.2189 6.77419C17.9688 6.83787 18.2739 7.77136 17.7064 8.26557L14.0426 11.4561C13.8047 11.6633 13.7008 11.985 13.7725 12.2922L14.876 17.0216C15.0474 17.7562 14.25 18.3347 13.6048 17.9438L9.44071 15.4206Z" fill="currentColor"/>
						</svg>
						${isPartialStar ? html`
							<div class="product-card__star-fill" style="width: ${partialFill}%"></div>
						` : ''}
					</div>
				`;
			})}
		</div>
	`;
}

// Helper function to convert English label to handlized key for translation lookup
const handleizeLabel = (label) => {
	return label
		.toLowerCase()
		.replace(/&/g, '')
		.replace(/-/g, ' ')
		.replace(/\s+/g, '_')
		.replace(/_+/g, '_')
		.replace(/^_|_$/g, '');
};

// Helper function to decode HTML entities
const decodeHtmlEntities = (str) => {
	const textarea = document.createElement('textarea');
	textarea.innerHTML = str;
	return textarea.value;
};

// Helper function to get translated label
const getTranslatedLabel = (label, type) => {
	const translations = window.algoliaFilterTranslations;
	if (!translations || !translations[type]) return label;
	
	const key = handleizeLabel(label);
	const translated = translations[type][key] || label;
	return decodeHtmlEntities(translated);
};